<template>
  <div class="m-product-card201 border">
    <m-single-product-wrapper :product-link="productLink" @product="dataReady">
      <template v-slot="{product}">
        <div class="row">

          <div class="col-12 m-0 p-3">
            <m-wish-list-button-1 :itemable_id="product.id"/>
          </div>

          <div class="col-md-6">
            <single-product-gallery2 class="p-2" :product="product"
                                     :gallery-full-slider="galleryFullSlider">

              <template #above_info>
                <div class="col-12 single-product-201-show-specified-feature font-weight-bolder my-3 "
                     v-if="showSpecifiedFeatureComputed && showSpecifiedFeatureMethod(product).length > 0">
                  {{ showSpecifiedFeatureMethod(product) }}
                </div>
              </template>


            </single-product-gallery2>


          </div>
          <div class="col-md-6 p-2">
            <div class="m-product-card201-content flex flex-column">
              <div class="d-inline-block" v-for="category in product.category">
                <m-a :href="{name:'Products',query:{category_column:'slug',category:category.slug}}"
                     class="m-product-card201-category1 text-white mx-1 px-3">
                  <span>{{ category.name }}</span>
                </m-a>
              </div>
              <h1 class="m-product-card201-title mt-4">{{ product.name }}</h1>
              <hr>

              <div class="m-product-abstract-201-wrapper py-3">
                <p class="m-product-abstract-201" v-html="product.abstract"></p>
              </div>

            </div>

            <div class="">
              <m-single-product-price3 class="single-product-201-price" :product="product"
                                       :showVariationProductImage="showVariationProductImage"/>
            </div>

          </div>


          <StoreDescription1 :product="product" v-if="productAuthor" :productAuthor="productAuthor"/>

          <slot>
            <div class="m-product-card201-banner col-12 mt-4 p-4 border">
              <i class="bi bi-ev-front p-1"></i>
              حمل و نقل سریع
              سفارش خود را قبل از ساعت 12:00 ظهر ثبت کنید تا امروز ارسال شود.
            </div>
          </slot>
        </div>
        <SingleProductDetail1 :mapFeatureName="mapFeatureName" :product="product"/>
      </template>
    </m-single-product-wrapper>
  </div>
</template>

<script>
import mSingleProductWrapper from "../../Wrappers/SingleProductWrapper.vue";
import mSingleProductPriceWrapper from "../SingleProductPriceWrapper.vue";
import mH2 from "../../Tags/H2.vue";
import mA from "../../Tags/A.vue";
import mProductPrice100 from "../ProductPrice100.vue";
import mSingleProductPrice3 from "../SingleProductPrice3/SingleProductPrice3.vue";
import mProductSlider1 from "../ProductSlider/ProductSlider1.vue";
import mCourseCard1 from "../../Course/Card/CourseCard1.vue";
import mStoreCard310 from "../../MultipleStore/Card/StoreCard310.vue";
import mHtmlToComponentWrapper from "../../Wrappers/HtmlToComponentWrapper.vue";
import {Cards} from "../Card/Cards";
import SingleProductGallery2 from "./Components/SingleProductGallery2.vue";
import SingleProductTableFeature1 from "./Components/SingleProductTableFeature1.vue";
import SingleProductDetail1 from "./Components/SingleProductDetail1.vue";
import mWishListButton1 from "../../WishList/Button/WishListButton1.vue";
import StoreDescription1 from "./SingleProduct201/StoreDescription1.vue";
import {
  productFeatureValue,
  productTableFeature,
  productFeatureName
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "SingleProduct201",
  components: {
    StoreDescription1,
    mWishListButton1,
    SingleProductDetail1,
    SingleProductTableFeature1,
    SingleProductGallery2,
    mSingleProductWrapper,
    mH2,
    mSingleProductPriceWrapper,
    mProductPrice100,
    mSingleProductPrice3,
    mProductSlider1,
    mA,
    mCourseCard1,
    mStoreCard310,
    mHtmlToComponentWrapper,
  },
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      type: Boolean,
      default: true
    },
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    relatedCourse: {
      type: Boolean,
      default: false,
    },
    galleryFullSlider: {
      type: Boolean,
      default: false
    },
    productAuthor: {
      type: Boolean,
      default: false
    },
    showSpecifiedFeature: {
      default: ''
    },
    showVariationProductImage: {
      type: Boolean,
      default: false,
    },
    mapFeatureName: {
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    showSpecifiedFeatureComputed() {
      return this.showSpecifiedFeature.length > 0
    }
  },
  methods: {
    productTableFeature,
    productFeatureName,
    productFeatureValue,
    tableFeature(product_features) {
      let product_variation = [];

      for (let feature in product_features) {
        feature = product_features[feature]
        // feature.type == 'list' &&  feature.feature_values.sub_product == 1 || feature.type == 'list' && feature.feature_values.sub_product == 0 && feature.feature_values.sub_product

        if (feature.feature_values.sub_product == 0 && feature.feature_values.variation == 0) {
          let feature_attribute_id = feature.feature_values.feature_attribute_id;
          let feature_attributes = feature.feature_attributes

          if (feature.type == 'text') {
            product_variation.push({text: feature.name, value: feature.feature_values.feature_value})
          }

          if (feature.type == 'list') {
            feature_attributes.forEach(item => {
              if (item.id == feature_attribute_id) {
                product_variation.push({...item, text: feature.name, value: item.value})
              }
            })

          }


        }

      }

      return product_variation
    },
    dataReady(product) {
    },
    productCategories(product) {
      if (product.category != undefined) {
        let categories = product.category.map(item => {
          return item.slug;
        })

        return categories.length == 0 ? null : categories
      }

    },
    productBrands(product) {
      const brand = product.brand;
      return brand == null ? null : [brand.slug];
    },
    showSpecifiedFeatureMethod(product) {

      let features = this.productTableFeature(product)
      let selectedFeature = ''
      features.forEach(item => {
        if (item.feature.name == this.showSpecifiedFeature) {
          selectedFeature = this.productFeatureName(product, item.id) + ': ' + this.productFeatureValue(product, item.id)
        }
      })

      return selectedFeature
    }
  },
};
</script>
<style scoped>
.m-product-card201 {
  border-radius: 1.1rem;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.m-product-card201-category1 {
  background-color: var(--primary);
  font-weight: bolder;
  border-radius: .75rem;
  font-size: smaller;
}

.m-product-card201-title {
  color: #1d1d1d;
  font-size: larger;
}

.m-product-card201-banner {
  border-radius: 1rem;
  background-color: var(--secondary);
}

.single-product-201-price {
  text-align: center;
}

.m-product-abstract-201 {
  font-size: 14px;


}

</style>